import React from 'react';

export const ConfirmModalContext = React.createContext({
    setShowConfirmModal: (showConfirmModal: boolean) => {},
    setConfirmModalText: (confirmModalText: string) => {},
    setOnConfirmModalConfirm: (onConfirm: () => () => Promise<boolean>) => {}
});